var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"boton-flotante",attrs:{"href":"http://web.farmaceuticaquiroga.com/#/login"}},[_c('i',{staticClass:"fa-solid fa-cart-shopping mr-2"})])])
}]

export { render, staticRenderFns }